export class AssetNiTransferSave {
    inventoryId: number;
    assetNiId: number;
}